<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>Program Not Found</h1>
    </div>

    <div class="container">
    </div><!-- container-fluid -->
  </div>
</template>

<script>
export default {
  name: 'ClientProgramNotFound'
}
</script>
